import { ITreeData } from '../entities';

export default function sortFieldsByType(fields: ITreeData[]) {
	const existTypes: string[] = [];

	fields.forEach(i => {
		if (!existTypes.includes(i.externalData.type)) {
			existTypes.push(i.externalData.type);
		}
	});

	let sortedFields: ITreeData[] = [];
	existTypes.sort();

	existTypes.forEach(type => {
		const fieldsByType: ITreeData[] = [];
		fields.forEach(field => {
			if (field.externalData.type === type) {
				fieldsByType.push(field);
			}
		});
		fieldsByType.sort((a, b) => a.key.localeCompare(b.key));
		sortedFields = [...sortedFields, ...fieldsByType];
	});

	return sortedFields;
}
